import shareConfig, { shareConfigProps } from './bridge/shareConfig'
import { sniff} from '@/util'
import { wxReadyHandle } from '@/hooks'

const updateAppShareDataConfig = function (config: shareConfigProps): void {
  if ( sniff.isUboxApp || sniff.isWechatMiniProgram ) {
    shareConfig(config)
  } else if (sniff.isWechat) {
    wxReadyHandle(config)
  }
}

export default updateAppShareDataConfig
